import { withNamespaces } from "react-i18next"
import { Col, Label, Row } from "reactstrap"
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";
import { Accordion } from "react-bootstrap";

const BasicInfosHeader = ({ t, detailsQuery }) => {
    const dateUtils = new DateUtils();

    if (detailsQuery.isFetching) {
        return null;
    }

    const {
        header = {}
    } = detailsQuery.data;

    return (
        <Accordion.Item
            className='active'
            eventKey={'basic-infos'}
        >
            <Accordion.Header>
                <span>
                    {header.reportName}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Row>
                    <Col sm="12" md="6" lg="6" className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-calendar-event-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Report Status Date')}:
                                </Label>
                                <p className="text-muted mb-0">
                                    {header.createdDate ? dateUtils.convertDateToDate(
                                        header.createdDate,
                                        INTERNATIONAL_DATE_FORMAT
                                    ) : '--'}
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg="6" className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-information-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Dataset Details')}:
                                </Label>
                                <p className="text-muted mb-0">
                                    {header.apiName || '--'}
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    BasicInfosHeader
)